<template>
  <div class="not-join-user-manager">
    <!-- 用户管理对话框 -->
    <el-dialog
      title="禁止参与用户管理"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="false"
      :close-on-click-modal="false"
      @opened="handleDialogOpened">
      
      <!-- 头部统计和操作区 -->
      <div class="header-section">
        <div class="stats-info">
          <span class="user-count">当前禁用用户：{{ filteredUsers.length }} 人</span>
        </div>
        
        <div class="header-actions">
          <!-- 单个添加 -->
          <div class="add-single">
            <el-input
              v-model="newUserId"
              placeholder="输入用户RID"
              size="small"
              style="width: 150px"
              @keyup.enter="addSingleUser"
              @input="validateInput">
            </el-input>
            <el-button 
              type="primary" 
              size="small" 
              @click="addSingleUser"
              :disabled="!newUserId.trim()">
              添加
            </el-button>
          </div>
          
          <!-- 批量添加按钮 -->
          <el-button 
            type="success" 
            size="small" 
            icon="el-icon-plus"
            @click="showBatchDialog">
            批量添加
          </el-button>
          
          <!-- 批量删除按钮 -->
          <el-button 
            type="danger" 
            size="small" 
            icon="el-icon-delete"
            @click="batchDeleteUsers"
            :disabled="selectedUsers.length === 0">
            批量删除 ({{ selectedUsers.length }})
          </el-button>
        </div>
      </div>
      
      <!-- 搜索框 -->
      <div class="search-section">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索用户RID..."
          size="small"
          clearable
          prefix-icon="el-icon-search"
          style="width: 200px">
        </el-input>
      </div>
      
      <!-- 用户列表表格 -->
      <div class="table-section">
        <el-table
          :data="paginatedUsers"
          style="width: 100%"
          height="300"
          @selection-change="handleSelectionChange"
          :empty-text="filteredUsers.length === 0 ? '暂无禁用用户' : '没有找到匹配的用户'">
          
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          
          <el-table-column prop="rid" label="用户RID" align="center" min-width="120">
            <template #default="{ row }">
              <span class="user-rid">{{ row.rid }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" align="center" width="120">
            <template #default="{ row, $index }">
              <div class="table-actions">
                <el-button 
                  size="mini" 
                  type="primary" 
                  icon="el-icon-copy-document"
                  @click="copyUserId(row.rid)"
                  title="复制RID">
                </el-button>
                <el-button 
                  size="mini" 
                  type="danger" 
                  icon="el-icon-delete"
                  @click="deleteUser($index + (currentPage - 1) * pageSize)"
                  title="删除用户">
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="filteredUsers.length > pageSize">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="filteredUsers.length"
            :page-size="pageSize"
            :current-page.sync="currentPage">
          </el-pagination>
        </div>
      </div>
      
      <!-- 底部操作 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="primary" @click="saveUsers">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 批量添加对话框 -->
    <el-dialog
      title="批量添加用户"
      :visible.sync="batchDialog.show"
      width="500px"
      :modal="false"
      :append-to-body="true">
      
      <div class="batch-add-content">
        <p style="margin-bottom: 10px; color: #666;">
          请输入要禁用的用户RID，多个用户请用逗号分隔：
        </p>
        <el-input
          type="textarea"
          :rows="6"
          placeholder="例如：123456,789012,345678"
          v-model="batchDialog.userIds"
          style="margin-bottom: 15px;">
        </el-input>
        <div style="font-size: 12px; color: #999;">
          <p>提示：</p>
          <p>1. 用英文逗号（,）分隔多个用户RID</p>
          <p>2. 系统会自动去重和验证格式</p>
          <p>3. 无效的RID将被自动过滤</p>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog.show = false">取消</el-button>
        <el-button type="primary" @click="addBatchUsers">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { copyToClipboard } from '@/utils/common'

export default {
  name: 'NotJoinUserManager',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 初始用户列表
    userList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.value,
      newUserId: '',
      searchKeyword: '',
      selectedUsers: [],
      currentPage: 1,
      pageSize: 10,
      
      // 用户列表（内部管理）
      users: [],
      
      // 批量添加对话框
      batchDialog: {
        show: false,
        userIds: ''
      }
    }
  },
  computed: {
    // 过滤后的用户列表
    filteredUsers() {
      if (!this.searchKeyword.trim()) {
        return this.users
      }
      return this.users.filter(user => 
        user.rid.toString().includes(this.searchKeyword.trim())
      )
    },
    
    // 分页后的用户列表
    paginatedUsers() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredUsers.slice(start, end)
    }
  },
  watch: {
    value(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initUserList()
      }
    },
    
    dialogVisible(newVal) {
      this.$emit('input', newVal)
    },
    
    // 监听搜索关键词变化，重置分页
    searchKeyword() {
      this.currentPage = 1
    }
  },
  methods: {
    // 对话框打开后的处理
    handleDialogOpened() {
      this.initUserList()
    },
    
    // 初始化用户列表
    initUserList() {
      if (this.userList && Array.isArray(this.userList)) {
        this.users = this.userList.map(rid => ({
          rid: rid.toString()
        }))
      } else {
        this.users = []
      }
      this.currentPage = 1
    },
    
    // 验证输入（只允许数字）
    validateInput(value) {
      // 移除非数字字符
      const numericValue = value.replace(/[^\d]/g, '')
      if (numericValue !== value) {
        this.newUserId = numericValue
      }
    },
    
    // 添加单个用户
    addSingleUser() {
      const userId = this.newUserId.trim()
      if (!userId) {
        this.$message.warning('请输入用户RID')
        return
      }
      
      // 检查是否重复
      if (this.users.some(user => user.rid === userId)) {
        this.$message.warning('该用户已在禁用列表中')
        this.newUserId = ''
        return
      }
      
      // 添加用户
      this.users.unshift({
        rid: userId
      })
      
      this.newUserId = ''
      this.$message.success('用户添加成功')
    },
    
    // 显示批量添加对话框
    showBatchDialog() {
      this.batchDialog.show = true
      this.batchDialog.userIds = ''
    },
    
    // 批量添加用户
    addBatchUsers() {
      const userIds = this.batchDialog.userIds.trim()
      if (!userIds) {
        this.$message.warning('请输入用户RID')
        return
      }
      
      // 解析用户ID列表
      const ridList = userIds.split(',')
        .map(id => id.trim())
        .filter(id => id && /^\d+$/.test(id)) // 只保留数字
        .filter((id, index, arr) => arr.indexOf(id) === index) // 去重
      
      if (ridList.length === 0) {
        this.$message.warning('没有找到有效的用户RID')
        return
      }
      
      // 检查重复并添加
      let addedCount = 0
      ridList.forEach(rid => {
        if (!this.users.some(user => user.rid === rid)) {
          this.users.unshift({
            rid: rid
          })
          addedCount++
        }
      })
      
      this.batchDialog.show = false
      this.batchDialog.userIds = ''
      
      if (addedCount > 0) {
        this.$message.success(`成功添加 ${addedCount} 个用户`)
      } else {
        this.$message.warning('所有用户都已在禁用列表中')
      }
    },
    
    // 删除用户（直接删除，无需确认）
    deleteUser(index) {
      this.users.splice(index, 1)
      this.$message.success('用户删除成功')
      
      // 如果当前页没有数据且不是第一页，则回到上一页
      if (this.paginatedUsers.length === 0 && this.currentPage > 1) {
        this.currentPage--
      }
    },
    
    // 复制用户ID
    copyUserId(rid) {
      copyToClipboard(rid.toString(), '用户RID已复制')
    },
    
    // 处理表格选择变化
    handleSelectionChange(selection) {
      this.selectedUsers = selection
    },
    
    // 批量删除用户（直接删除，无需确认）
    batchDeleteUsers() {
      if (this.selectedUsers.length === 0) {
        this.$message.warning('请选择要删除的用户')
        return
      }
      
      // 获取要删除的用户RID
      const ridsToDelete = this.selectedUsers.map(user => user.rid)
      
      // 从用户列表中删除
      this.users = this.users.filter(user => !ridsToDelete.includes(user.rid))
      
      this.$message.success(`成功删除 ${ridsToDelete.length} 个用户`)
      
      // 清空选择
      this.selectedUsers = []
      
      // 检查分页
      if (this.paginatedUsers.length === 0 && this.currentPage > 1) {
        this.currentPage--
      }
    },
    
    // 保存用户列表
    saveUsers() {
      // 转换为整数数组以符合API要求
      const userRids = this.users.map(user => parseInt(user.rid)).filter(rid => !isNaN(rid))
      this.$emit('save', userRids)
      this.closeDialog()
    },
    
    // 关闭对话框
    closeDialog() {
      this.dialogVisible = false
      this.newUserId = ''
      this.searchKeyword = ''
      this.selectedUsers = []
      this.currentPage = 1
    }
  }
}
</script>

<style scoped lang="scss">
.not-join-user-manager {
  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    .stats-info {
      font-size: 16px;
      color: #333;
    }

    .header-actions {
      display: flex;
      gap: 10px;

      .add-single {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }

  .search-section {
    margin-bottom: 15px;
    text-align: right;
  }

  .table-section {
    .el-table {
      .user-rid {
        color: #409EFF;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .table-actions {
        display: flex;
        gap: 5px;
      }
    }

    .pagination-wrapper {
      margin-top: 15px;
      text-align: center;
    }
  }
}

.batch-add-content {
  .el-textarea__inner {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.4;
  }
  
  p {
    margin: 4px 0;
    line-height: 1.4;
  }
}
</style> 